import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface CryptoOnchainMethodBadgeProps {
  /** `ETH (Ethereum Sepolia)`; omitted where the table shows it in its own column. */
  assetLabel?: string;
  /** Paid on a testnet (the store was in sandbox mode): no real money moved. */
  isTest: boolean;
  className?: string;
}

/** The Payment method cell of an on-chain crypto payment: `Crypto`, the coin and network, and Test on a testnet. */
export function CryptoOnchainMethodBadge({ assetLabel, isTest, className }: CryptoOnchainMethodBadgeProps) {
  const { t } = useTranslation('common');
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Badge variant="gray" className="min-w-[72px] justify-center">
        {t('cryptoOnchain.method')}
      </Badge>
      {assetLabel && <span className="text-muted-foreground whitespace-nowrap text-sm">{assetLabel}</span>}
      {isTest && <Badge variant="blue">{t('cryptoOnchain.test')}</Badge>}
    </div>
  );
}
